// extracted by mini-css-extract-plugin
export default {"root":"oV2fD","text":"dLe3h","title":"Y2xMZ","description":"t2TPx"};